/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { UiService } from '@services/ui/ui.service';
import { AppService } from '@services/app/app.service';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dynamic-input',
  templateUrl: './dynamic-input.component.html',
  styleUrls: ['./dynamic-input.component.scss'],
  standalone: false
})
export class DynamicInputComponent {
  /**
   * id elemento
   */
  @Input() id: string;

  /**
   * titolo (label) dell'input
   */
  @Input() title: string;

  /**
   * titolo tooltip
   */
  @Input() tooltipTitle: string;

  /**
   * testo tooltip
   */
  @Input() tooltip: string;

  /**
   * flag per regolare il render dell'input
   */
  @Input() visible: boolean;

  /**
   * flag per indentificare il titolo come obbligatorio
   */
  @Input() required: boolean;

  /**
   *flag che nasconde simbolo di obbligatorio
   */
  @Input() hideMandatorySign: boolean;

  /**
   * tipologia input
   */
  @Input() cssClass: string;

  /**
   * flag che indica se si utilizzerà aria per il titolo
   */
  @Input() skipAriaTitleAdaptation: boolean;

  constructor(private uiService: UiService, private appService: AppService) {}

  async openTooltip(event: any): Promise<void> {
    if (!this.tooltip) {
      return;
    }

    const tooltipInterface = this.appService.getConfig().theme.tooltipInterface;

    switch (tooltipInterface) {
      case 'modal':
        return this.openTooltipAsModal();
      case 'popover':
      default:
        return this.openTooltipAsPopover(event);
    }
  }

  private openTooltipAsModal(): Promise<void> {
    return this.uiService.showTooltipAsModal({
      title: this.tooltipTitle,
      description: this.tooltip
    });
  }

  private openTooltipAsPopover(event: any): Promise<void> {
    return this.uiService.showTooltipAsPopover({
      title: this.tooltip,
      event
    });
  }
}
